// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"tD-z","smallCardRow":"uD-z","largeCardRow":"vD-z","productSearchRow":"wD-z","curatedRow":"xD-z"};